<template>
  <div class="newsDetails">
  	<div class="main-banner" :style="'background-image: url('+bannerList+');'">
  	</div>
  	<div class="main">
			<div class="container">
				<h4>{{$AppLang == 'en' ? newsData.titleEn : newsData.title}}</h4>
				<span>{{newsData.updateTime}}</span>
				<div class="text" v-html="$AppLang == 'en' ? newsData.contentEn : newsData.content"></div>
				<!-- <div class="page">
					<div>上一篇：完好的售后服务是抖音运营企业发展的基石</div>
					<div>下一篇：没有了</div>
				</div> -->
			</div>
  	</div>

  </div>
</template>

<script>
  export default {
  	name: 'newsDetails',
  	data() {
  		return {
        newsData:{},
				bannerList: [],
  		};
  	},
		mounted() {
			this.bannerApi();
		},
    created(){
      var that = this;
      var newsId = '';
      newsId = this.$route.query.newsId;

      that.$api.post(
      	'/news/newsInfo',
      	{
      		newsId: newsId
      	},
      	function(res) {
      		if(res.data.rtnCode == 200){
      			var list = res.data.data;
      			that.newsData = list;
      		}else{
      			alert(res.data.msg);
      		}
      	}
      );
    },
		methods:{
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 3
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}

					}
				);
			}
		},
    metaInfo: {
      title: '佛山鼎吉-新闻详情', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.newsDetails{
	background: #FFFFFF;
	padding-bottom: 50px;
}
.newsDetails .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.newsDetails .main{
	padding-top: 50px;
}
.newsDetails h4{
	font-size: 24px;
	text-align: center;
	margin-bottom: 30px;
}
.newsDetails .main .text{
	margin-top: 40px;
	margin-bottom: 50px;
}
.newsDetails .main .text img{
  margin: 20px 0;
}
.newsDetails .main .text p{
	text-align: justify;
	font-size: 14px;
}
.newsDetails .main .page{

}
.newsDetails .main .page div{
	text-align: left;
	margin-bottom: 10px;
}
@media (max-width: 992px){
  .newsDetails h4{
    font-size: 20px;
  }
  .newsDetails .main .page div{
    font-size: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/news/news-details.vue